// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"0b8fe670","453":"ca06489e"}[chunkId] + ".chunk.js";
};